setUserGiftSubscriptionsWithDetails